import {
  AlertDialogActionsWrapper,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
} from 'components/alert-dialog';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledAlertDialogOverlay = styled(AlertDialogOverlay)`
  ${AlertDialogContent} {
    max-width: ${rem(500)};
  }

  ${AlertDialogDescription} {
    ul {
      margin: 0;
      padding: 0;
    }

    li {
      margin: ${rem(10)} 0;
      list-style: none;
    }
  }

  ${AlertDialogActionsWrapper} {
    display: grid;
    grid-gap: ${rem(20)};
    grid-template-columns: repeat(auto-fill, minmax(${rem(200)}, 1fr));

    * {
      margin: 0;
    }
  }
`;
